import { isDefined } from '@sgme/fp';
import { makeValuesPredicate } from '@sgme/fp';
import { DocumentationV3, DocumentItem } from 'epic/common-form/Documentation';
import { DocumentType } from 'models/documents/DocumentType';
import type { IBlotterItem } from 'models/IBlotterItem';

const needsProductId = makeValuesPredicate([
  'PreConfirmation',
  'MarketingMaterial',
  'TermSheet',
] satisfies DocumentType[]);

export function getDocumentOfType(
  documents: DocumentationV3,
  type: DocumentType,
  blotterItem?: IBlotterItem,
): DocumentItem[] {
  const document = documents.docs.find(doc => doc.type === type);
  if (blotterItem?.blotterItemType === 'DlpProduct') {
    return document?.items ?? [];
  }
  if (!needsProductId(type) || isDefined(blotterItem?.productId)) {
    return document?.items ?? [];
  } else {
    return [];
  }
}
